import * as React from 'react';
import {
	Dropdown,
	DropdownContent,
	DropdownEllipsisTrigger,
	DropdownItem,
} from '../../../../../web/components-v2/Dropdown';

interface IProps {
	onClickToArchive?: () => void;
	onClickToBrowse?: () => void;
}

export const CategoryCardOptions: React.FC<IProps> = ({ onClickToArchive, onClickToBrowse }) => {
	return (
		<Dropdown modal={false}>
			<DropdownEllipsisTrigger aria-label='Category actions' />
			<DropdownContent align='end'>
				<DropdownItem onClick={onClickToBrowse}>Browse Calls</DropdownItem>
				<DropdownItem onClick={onClickToArchive}>Archive</DropdownItem>
			</DropdownContent>
		</Dropdown>
	);
};
